<template>
  <div class="dropdown c-dropdown">
    <div class="dropdown-trigger">
      <button aria-controls="dropdown-menu2" aria-haspopup="true" class="button">
        <span>{{ selectedOption.label }}</span>
        <img alt=" " src="/static/img/arrows/arrow_down2.svg"/>
      </button>
    </div>
    <div id="dropdown-menu2" class="dropdown-menu" role="menu">
      <div class="dropdown-content">
        <div class="dropdown-item dropdown-item-header">
          {{ ddLabel }}
        </div>
        <hr class="dropdown-divider">
        <template v-for="(option, idx) in ddOptions">
          <div class="dropdown-item">
            <label class="radio c-radio">
              <input v-model="selectedRadioVal" :name="radioName" :value="option.value" type="radio">
              {{ option.label }}
            </label>
            <tooltip v-if="'tooltip' in option && option.tooltip.content" :iconRight="iconRight" :iconTop="iconTop"
                     :tooltipRight="tooltipRight" :tooltipTop="tooltipTop">
              <p>{{ option.tooltip.content }}</p>
            </tooltip>
          </div>
          <hr v-if="idx !== ddOptions.length-1" class="dropdown-divider">
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Tooltip from '../Tooltip'
import { misc } from '@/mixins'

export default {
  name: 'BulmaDropdown',
  mixins: [misc],
  components: {
    Tooltip
  },
  props: {
    ddLabel: {
      type: String,
      required: true
    },
    ddOptions: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      radioName: this.toSnakeCase(this.ddLabel.toLowerCase()),
      selectedRadioVal: (this.ddOptions.find(option => 'selected' in option && option.selected)).value
    }
  },
  computed: {
    selectedOption () {
      return this.ddOptions.find(option => this.selectedRadioVal === option.value)
    },
    iconRight () {
      if (this.isMobile) {
        return 28
      }
      return 19
    },
    iconTop () {
      if (this.isMobile) {
        return 3
      }
      return 5
    },
    tooltipRight () {
      if (this.isMobile) {
        return 35
      }
      return 26
    },
    tooltipTop () {
      if (this.isMobile) {
        return 9
      }
      return 5
    }
  },
  watch: {
    selectedRadioVal: function (newVal) {
      this.$emit('bulmaDdChange', {
        key: this.ddLabel,
        value: newVal
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/vendor/_breakpoints.scss";

.dropdown {
  .dropdown-trigger button {
    justify-content: space-between;
    border-radius: 3px;
    border: 1px solid rgba(88, 89, 91, 0.32);
    color: map-get($colors, 'gray');
    height: 34px;
    padding: 8px 8px 3px 12px;
    width: 209px;
    font-size: 12px;

    @include not-mobile {
      width: 257px;
      font-size: 16px;
      padding: 6px 8px 3px 12px;
      height: auto;

      img {
        margin-top: 5px;
      }
    }
  }

  .dropdown-menu {
    padding-top: 0;
    width: 257px;
    margin-top: 5px;

    @include mobile {
      width: 209px;
    }

    .dropdown-content {
      border-radius: 3px;
      border: 1px solid rgba(88, 89, 91, 0.32);
      box-shadow: none;

      .dropdown-item-header {
        font-weight: bold;

        @include mobile {
          font-size: 14px !important;
        }
      }

      .dropdown-divider {
        opacity: 0.1;
        background-color: #67717a;
      }

      .dropdown-item {
        color: map-get($colors, 'gray');
        font-size: 16px;
        padding: 0 19px 0 24px;

        @include mobile {
          font-size: 12px;
          padding: 0 15px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dropdowns/BulmaDropdown.vue